import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/onlinePayment/initiate', request)
}

export {post}
